export const API_RETRY_COUNT = 3; // Number of retry attempts
export const API_RETRY_BASE_DELAY_MS = 1000; // Delay between retries in milliseconds

let config = null;

export async function loadConfig() {
  const res = await fetch('/config.json', { cache: 'no-store' });
  config = await res.json();
}

export function getConfig() {
  if (!config) {
    throw new Error('Config not loaded yet');
  }
  return config;
}
